import { render, staticRenderFns } from "./CreateEditForm.vue?vue&type=template&id=2efeddb7&lang=pug&"
import script from "./CreateEditForm.vue?vue&type=script&lang=js&"
export * from "./CreateEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports